module.exports = __webpack_public_path__ + "img/faming11.42e30845.png";